export default "__VITE_ASSET__BP$J_HIe__"